export default __webpack_public_path__ + "static/media/mr-minh.f16b5c25.png";